import Header from "../components/Header";

export default function Home() {
    return (
        <>
            <Header />
            <div className='yellow'>404</div>
        </>
    );
};